import classnames from 'classnames';
import {formatPaymentMethod} from '@ppcp/utils';
import {useProcessFastlaneToken, useManageFastlaneToken} from "./hooks";

export default function TokenizedCard(
    {
        data,
        token,
        fastlane,
        customerFound,
        ...props
    }) {

    const {
        i18n,
        icons,
        payment_format
    } = data;

    const {
        cartData,
        emitResponse,
        eventRegistration,
        shouldSavePayment
    } = props;

    const {
        onPaymentSetup
    } = eventRegistration;

    const {
        extensions
    } = cartData;

    const needsSetupToken = extensions?.wc_ppcp?.needsSetupToken || false;

    let {
        card
    } = token.paymentSource;

    card = {
        ...card,
        brand: card.brand,
        last4: card.lastDigits,
        expiry: card.expiry
    };

    useProcessFastlaneToken({
        token,
        emitResponse,
        onPaymentSetup,
        needsSetupToken,
        shouldSavePayment
    });

    const {
        onCancel,
        onChangePaymentMethod
    } = useManageFastlaneToken({
        fastlane
    });

    return (
        <div className={classnames('wc-ppcp-tokenized-card', {'has-customer-context': customerFound})}>
            <CardIcon icons={icons} brand={card.brand.toLowerCase()}/>
            <div className="wc-ppcp-tokenized-card-format">
                {formatPaymentMethod(payment_format, card)}
            </div>
            <div className="wc-ppcp-tokenized-card-actions">
                <a
                    className="wc-ppcp-tokenized-card-cancel"
                    onClick={onCancel}>
                    {i18n.cancel}
                </a>
                {customerFound &&
                    <a
                        className="wc-ppcp-tokenized-card-change"
                        onClick={onChangePaymentMethod}>
                        {i18n.change}
                    </a>
                }
            </div>
        </div>
    )
}

const CardIcon = ({icons, brand}) => {
    let src = '';

    if (icons[brand]) {
        src = icons[brand];
    }

    return (
        <div className="wc-ppcp-tokenized-card-icon-container">
            <img src={src}/>
        </div>
    )
}